module.exports = __webpack_public_path__ + "img/Prunus_persica.e7e0ad0e.jpg";